import React from 'react';
import styled from 'styled-components';
import { ICircleBulletCmp } from './ICircleBulletCmp';

interface IStyledProps {
  active: boolean;
}
const Circle = styled.div<IStyledProps>`
  width: 10px;
  height: 10px;
  border: solid;
  border-width: 1px;
  border-color: ${props => props.theme.paletteDefault.grey1};
  border-radius: 50%;
  position: relative;
  background: ${props => props.theme.paletteDefault.white};
  margin-right: 8px;

  &:after {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${props =>
      props.active ? props.theme.filterPanel.numSelectedItemsBg : ''};
    background-size: 100%;
  }
`;

const CircleBullet: React.FC<ICircleBulletCmp> = ({ active }) => {
  return <Circle active={active} />;
};

export default CircleBullet;
